<script>
import baseList from "@/views/components/base/baseList.vue";
import { Button } from "view-design";
import Deal from "./deal.vue";

export default {
  extends: baseList,
  components: {
    deal: Deal,
  },
  data() {
    return {
      table: {
        mname: "user",
        key: "uid",
        url: {},
        output: false,
      },
      menus: [
        {
          label: "用户列表",
          name: "user_list",
          auth: "/admin/user/lists",
        },
        {
          label: "浏览记录",
          name: "record_list",
          auth: "/admin/record/lists",
        },
      ],
      actions: [
        // {label: '新增', icon: 'md-add', onClick: this.toAdd, auth1: '/admin/user/add'},
      ],
      tactions: [
        //   { label: '导出数据', type: 'success', onClick: this.exportData.bind(this, '用户数据', 0), auth: '/admin/user/lists' },
        //   { label: '导出全部数据', type: 'error', onClick: this.exportData.bind(this, '用户数据', 1), auth: '/admin/user/lists' },
      ],
      query: {},
      filters: [
        { label: "昵称", name: "user_nick", value: "", type: "input" },
        {label: '手机号', name: 'user_mobile', value: '', type: 'input'},
        // {
        //   label: "性别",
        //   name: "user_gender",
        //   value: 1,
        //   type: "select",
        //   dropList: [
        //     { value: "1", name: "男" },
        //     { value: "2", name: "女" },
        //   ],
        // },
      ],
      tableCols: [
        // {
        //   type: 'selection',
        //   width: 60,
        // },
        {
          title: "UID",
          key: "uid",
          minWidth: 80,
          align: "center",
        },
        {
          title: "头像",
          key: "user_head",
          width: 100,
          align: "center",
          isAvatar: true,
          viewimage: true,
        },
        {
          title: "昵称",
          key: "user_nick",
          minWidth: 120,
        },
        // {
        //   title: "村组",
        //   key: "category_name",
        //   minWidth: 120,
        // },
        // {
        //   title: "户主",
        //   key: "head_name",
        //   minWidth: 120,
        // },
        {
          title: "手机号",
          key: "user_mobile",
          minWidth: 120,
        },
        {
          title: "用户标签",
          minWidth: 120,
          key: "tags_name",
          align: "center",
        },
        // {
        //   title: "积分",
        //   key: "point",
        //   minWidth: 120,
        // },
        // {
        //   title: "是否实名",
        //   align: "center",
        //   key: "is_real",
        //   minWidth: 100,
        //   switch: true,
        //   disabled: false,
        // },
        // {
        //   title: "是否实名",
        //   key: "is_real",
        //   minWidth: 120,
        //   align: "center",
        //   render: (h, params) => {
        //     const row = params.row;
        //     const color =
        //       row.is_real == 1 ? "blue" : row.is_real == 0 ? "red" : "";
        //     const text =
        //       row.is_real == 1 ? "是" : row.is_real == 0 ? "否" : "";
        //     return (
        //       <span style={{ color: color, "font-size": "14px" }}>{text}</span>
        //     );
        //   },
        // },
        // {
        //   title: "性别",
        //   key: "user_gender",
        //   minWidth: 70,
        //   align: "center",
        //   render: (h, params) => {
        //     const row = params.row;
        //     const color =
        //       row.user_gender == 1 ? "blue" : row.user_gender == 2 ? "red" : "";
        //     const text =
        //       row.user_gender == 1 ? "男" : row.user_gender == 2 ? "女" : "";
        //     return (
        //       <span style={{ color: color, "font-size": "14px" }}>{text}</span>
        //     );
        //   },
        // },
        {
          title: "账号状态",
          align: "center",
          key: "status",
          minWidth: 100,
          switch: true,
          disabled: false,
        },
        {
          title: "备注",
          align: "center",
          key: "remark",
          minWidth: 120,
        },
        {
          title: "创建时间",
          key: "create_time",
          minWidth: 220,
          align: "center",
        },
        {
          title: "操作",
          align: "center",
          minWidth: 280,
          key: "handle",
          fixed: "right",
          handle: [
            (vm, h, currentRow, param) => {
              const row = param.row;
              let directives = [
                { name: "auth", value: "/admin/record/lists" },
              ];
              this.currentRow = currentRow;
              return <Button
                  {...{ directives }}
                  size="small"
                  onClick={() => this.toComment(currentRow)}
                  type="info"
                  style={{ margin: "4px 5px" }}
                >
                  浏览记录
                </Button>
            },
            (vm, h, currentRow, param) => {
              const row = param.row;
              let directives = [
                { name: "auth", value: "/admin/user/edit" },
              ];
              this.currentRow = currentRow;
              return <Button
                  {...{ directives }}
                  size="small"
                  onClick={() => this.toEdit(currentRow)}
                  type="warning"
                  style={{ margin: "4px 5px" }}
                >
                  绑定用户标签
                </Button>
            },"delete"],
          auth: {
            del: "/admin/user/del",
          },
        },
      ],
    };
  },
  created() {},
  methods: {
    toEdit(row) {
      let uid = row.uid;
      $utils.url.push({
        name: "user_edit",
        query: { action: "edit", kv: uid },
      });
    },
    toComment(row) {
      let uid = row.uid;
      $utils.url.push({
        name: "record_list",
        query: {  kv: uid },
      });
    },
  },
};
</script>
